/**
 * Created with IntelliJ IDEA.
 * User: elinar
 * Date: 11/26/14
 * Time: 5:47 PM
 * To change this template use File | Settings | File Templates.
 */


define(function (require) {
    "use strict";

    var Marionette = require("marionette");

    var UserBarWidgetsLayoutController = Marionette.Controller.extend({
        initialize : function (options) {
            this.LE = options.application;
            this.userBarWidgetsLayout=options.userBarWidgetsLayout;
            this._setEventListeners();
        },
        _setEventListeners:function(){
            this.LE.vent.on("userBarWidgetsLayoutController:showRegion",this._showRegion,this);
        },
        _showRegion:function(options){
            if(!this._isShowRegionsOptionsValid(options)){return;}
            this.userBarWidgetsLayout[options.region].show(options.view);
        },
        _isShowRegionsOptionsValid:function(options){
            if(!options){
                return false;
            }
            var isValid=true;

            if(!options.region){
                isValid = false;
            }
            if(!options.view){
                isValid = false;
            }
            return isValid;
        }
    });
    return UserBarWidgetsLayoutController;
});
